import $ from 'jquery';
import {brandSubscribe, emailSubscribe, sizeSubscribe} from '../api/api';
import heightAnimate from '../../scripts/util/animate/heightAnimate';

export default class MySubscribes {
	constructor(options) {
		const defaults = {
			el: '.js-subscribes',

			dom: {
				data: '.js-subscribes-data',
				add: '.js-subscribes-add',
				content: '.js-subscribes-content',
				selectedTmpl: '#js-selected-tmpl',
				selected: '.js-selected',
				brandCheckbox: '.js-brand-checkbox',
				brandTitle: '.js-brand-title',
				brandContainer: '.js-brand-container',
				brandRemove: '.js-brand-remove',
				brandClear: '.js-brand-clear',
				emailSubscribe: '.js-email-subscribe',
				emailSubmit: '.js-submit-email',
				sizeCheckbox: '.js-size-checkbox',
				alphabet: '.js-alphabet-subscribes',
				brandList: '.js-brand-list'
			},
			classes: {
				brandClear: {
					state: {
						hidden: 'my-subscribes__clear_state_hidden'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
	}

	getDom() {
		this.$data = this.$el.find(this.options.dom.data);
		this.$add = this.$el.find(this.options.dom.add);
		this.$content = this.$el.find(this.options.dom.content);
		this.$selectedTmpl = this.$el.find(this.options.dom.selectedTmpl).clone();
		this.$brandCheckbox = this.$el.find(this.options.dom.brandCheckbox);
		this.$brandContainer = this.$el.find(this.options.dom.brandContainer);
		this.$brandRemove = this.$el.find(this.options.dom.brandRemove);
		this.$brandClear = this.$el.find(this.options.dom.brandClear);
		this.$brandAlphabet = this.$el.find(this.options.dom.brandAlphabet);
		this.$emailSubmit = this.$el.find(this.options.dom.emailSubmit);
		this.$sizeCheckbox = this.$el.find(this.options.dom.sizeCheckbox);
		this.$alphabet = this.$el.find(this.options.dom.alphabet);
		this.$brandList = this.$el.find(this.options.dom.brandList);
		this.$el.find(this.options.dom.selectedTmpl).remove();
	}

	setClearDisplaying() {
		if (this.$brandContainer.find(this.options.dom.selected).length) {
			this.$brandClear.removeClass(this.options.classes.brandClear.state.hidden);
		} else {
			this.$brandClear.addClass(this.options.classes.brandClear.state.hidden);
		}
	}

	showContent(e) {
		const $target = $(e.target);
		const $data = $target.closest(this.options.dom.data);
		const $content = $data.find(this.options.dom.content);

		$target.addClass('hidden');
		heightAnimate($content, 0.4);
	}

	selectBrand(e) {
		const $newNode = this.$selectedTmpl.clone();
		const $currentTarget = $(e.currentTarget);
		if ($currentTarget.is(':checked')) {
			const $target = $currentTarget.next();
			$newNode.find(this.options.dom.brandTitle).text($target.text());
			$newNode.attr('data-id', $currentTarget.attr('id'));
			$newNode.find(this.options.dom.brandRemove).on('click', evt => this.removeBrand(evt));
			this.$brandContainer.append($newNode);
			brandSubscribe({
				id: $currentTarget.attr('id'),
				subscribe: 1
			});
		} else {
			const id = $currentTarget.attr('id');
			this.$brandContainer.find(`${this.options.dom.selected}[data-id="${id}"]`).remove();
			brandSubscribe({
				id,
				subscribe: 0
			});
		}
		this.setClearDisplaying();
	}

	removeBrand(e) {
		const $target = $(e.target);
		this.getBrandId().then($item => {
			const id = $item.attr('data-id');
			this.$el.find(`#${id}`).prop('checked', false);
			$item.remove();
			brandSubscribe({
				id,
				subscribe: 0
			});
			this.setClearDisplaying();

		});
		$target.trigger('getId');

	}

	getBrandId() {
		return new Promise(( resolve, reject ) => {
			this.$brandContainer.find(this.options.dom.selected).on('getId', e => {
				const item = $(e.currentTarget);
				if (item.length) {
					resolve(item);
				} else {
					reject(new Error('atribute not found'));
				}
			});
		});
	}

	brandClear() {
		const $items = this.$brandContainer.find(this.options.dom.selected);
		$items.each(item => {
			const $brand = $items.eq(item);
			const id = $brand.attr('data-id');
			this.$el.find(`#${id}`).prop('checked', false);
			$brand.remove();
			brandSubscribe({
				id: 'all',
				subscribe: 0
			});
		});
		this.setClearDisplaying();
	}

	emailSubscribe() {
		const $subscribes = this.$el.find(this.options.dom.emailSubscribe + ':checked');
		const subscribes = [];

		$subscribes.each(item => {
			subscribes.push($subscribes.eq(item).attr('id'));
		});

		emailSubscribe({
			items: subscribes
		});
	}

	sizeSubscribe(e) {
		const $currentTarget = $(e.currentTarget);
		if ($currentTarget.is(':checked')) {
			sizeSubscribe({
				id: $currentTarget.attr('id'),
				subscribe: 1
			});
		} else {
			sizeSubscribe({
				id: $currentTarget.attr('id'),
				subscribe: 0
			});
		}

	}

	clickAlphabet(e) {
		e.preventDefault();
		const $target = $(e.currentTarget);
		const href = $target.attr('href');
		this.$brandList.mCustomScrollbar('scrollTo', href, {scrollInertia: 1000, scrollEasing: 'easeOut'});

	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.$add.on('click', this.showContent.bind(this));
			this.$brandCheckbox.on('change', e => this.selectBrand(e));
			this.$brandRemove.on('click', e => this.removeBrand(e));
			this.$brandClear.on('click', e => this.brandClear(e));
			this.$brandAlphabet.on('click', e => this.sortAlphabet(e));
			this.$emailSubmit.on('click', e => this.emailSubscribe(e));
			this.$sizeCheckbox.on('click', e => this.sizeSubscribe(e));
			this.$alphabet.find('a').on('click', e => this.clickAlphabet(e));
		}
		return this;
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/my-subscribes/my-subscribes.js
 **/